// removed by extract-text-webpack-plugin
module.exports = {"flex":"src-components-modules-SecuritySection-style----security-card-module---flex---3bupV display-flex borderRadius-l","raised":"src-components-modules-SecuritySection-style----security-card-module---raised---1jkDg bg-snow","circle":"src-components-modules-SecuritySection-style----security-card-module---circle---1iacp marginRight-m display-block overflow-hidden borderRadius-circle","content":"src-components-modules-SecuritySection-style----security-card-module---content---12LY- flex-1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/SecuritySection/style/security-card.module.css
// module id = 740
// module chunks = 47877783677342 112587981740051